import { supabase } from '@/integrations/supabase/client';

export interface ContactFormData {
  name: string;
  email: string;
  company: string;
  message: string;
}

export class ContactService {
  /**
   * Send Enterprise contact form email via Supabase Edge Function
   */
  static async sendEnterpriseInquiry(formData: ContactFormData): Promise<{ success: boolean; error?: string }> {
    try {
      // For contact form, we don't require authentication
      // The Edge Function will handle unauthenticated requests
      const { data, error } = await supabase.functions.invoke('send-contact-email', {
        body: formData
      });

      if (error) {
        console.error('Error calling send-contact-email function:', error);
        throw error;
      }

      if (!data?.success) {
        throw new Error(data?.error || 'Failed to send email');
      }

      return { success: true };
    } catch (error) {
      console.error('Error sending contact form:', error);
      return { 
        success: false, 
        error: error instanceof Error ? error.message : 'Failed to send message' 
      };
    }
  }
} 